"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetThemeSwipeResponseDto = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var WidgetThemeSwipeResponseItemImageDto = zod_1.z.object({
    url: zod_1.z.string(),
});
/**
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_theme_swipe_dto_widget_v1_theme_swipe_response_dto._internal_.WidgetThemeSwipeResponseItemLogMetaDto.html}
 * */
var WidgetThemeSwipeResponseItemLogMetaDto = zod_1.z.object({
    deepLinkUri: zod_1.z.string(),
    object: zod_1.z.string(),
    objectType: zod_1.z.string(),
    position: zod_1.z.number(),
    themeStoreItemId: zod_1.z.string(),
});
/**
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_theme_swipe_dto_widget_v1_theme_swipe_response_dto._internal_.WidgetThemeSwipeResponseLogMetaDto.html}
 * */
var WidgetThemeSwipeResponseLogMetaDto = zod_1.z.object({
    objectContainer: zod_1.z.string(),
    themeStoreId: zod_1.z.string(),
    widgetTitle: zod_1.z.string().nullish(),
});
/**
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_theme_swipe_dto_widget_v1_theme_swipe_response_dto._internal_.WidgetThemeSwipeResponseItemDto.html}
 * */
var WidgetThemeSwipeResponseItemDto = zod_1.z.object({
    action: common_1.CommonResponseItemActionDto,
    image: WidgetThemeSwipeResponseItemImageDto,
    title: zod_1.z.string(),
    logMeta: WidgetThemeSwipeResponseItemLogMetaDto,
});
/**
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_theme_swipe_dto_widget_v1_theme_swipe_response_dto.WidgetV1ThemeSwipeResponseDto.html}
 * */
exports.WidgetThemeSwipeResponseDto = zod_1.z.object({
    header: common_1.CommonWidgetV2HeaderDto.nullish(),
    items: zod_1.z.array(WidgetThemeSwipeResponseItemDto),
    logMeta: WidgetThemeSwipeResponseLogMetaDto,
});
